import {Component, Input, OnChanges, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-why-lib-file-viewer',
  template: `
    <div class="image-viewer" [ngSwitch]="fileType">
      <!-- Show Image file preview -->
      <ng-container *ngSwitchCase="'image'">
        <img [src]="fileUrl | SafeUrl" alt="file"/>
      </ng-container>

      <!-- Show video file preview -->
      <ng-container *ngSwitchCase="'video'">
        <video [src]="fileUrl | SafeUrl"></video>
      </ng-container>

      <!-- Show audio file preview -->
      <ng-container *ngSwitchCase="'audio'">
        <audio [src]="fileUrl | SafeUrl"></audio>
      </ng-container>

      <!-- If fle is not of type image or video show an alert -->
      <ng-container *ngSwitchDefault>
        File preview is not available
      </ng-container>
    </div>
  `,
  styleUrls: [
    'file-viewer.component.scss'
  ],
  encapsulation: ViewEncapsulation.None
})
export class FileViewerComponent implements OnInit, OnChanges {
  @Input() file: File;

  fileType;
  fileUrl;

  constructor() {
  }

  ngOnChanges(): void {
    this.fileUrl = window.URL.createObjectURL(this.file);
    this.fileType = this.file.type.split('/').shift();
  }

  ngOnInit(): void {
  }
}
